import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("igRYP"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("c7wXz"), parcelRequire.load("jsgHa"), parcelRequire.load("cfjIz"), parcelRequire.load("glNyF"), parcelRequire.load("c6gg0"), parcelRequire.load("hLWGj")]).then(() => {
let originalModule = parcelRequire("i9ilt");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("c7wXz")} />
  <link rel="modulepreload" href={parcelRequire.resolve("jsgHa")} />
  <link rel="stylesheet" href={parcelRequire.resolve("igRYP")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("cfjIz")} />
  <link rel="modulepreload" href={parcelRequire.resolve("glNyF")} />
  <link rel="modulepreload" href={parcelRequire.resolve("c6gg0")} />
  <link rel="modulepreload" href={parcelRequire.resolve("hLWGj")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
